import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Button, LinkButton, Stack } from '@lyearn/ui';

import { filterButtonsStyles } from './style';
import { FilterActionProps } from './types';

function FilterActionsDesktop(props: FilterActionProps) {
  const { t } = useTranslation();
  const { onClear, onSave, disabled } = props;

  return (
    <>
      <Box className="mb-12 h-1 w-full flex-shrink-0 bg-divider" />
      <Stack alignItems="center" className="flex-shrink-0 px-10 pb-12" justifyContent="between">
        <LinkButton
          className={cn(filterButtonsStyles, 'py-2 px-4')}
          color={'internal'}
          onClick={onClear}>
          {t('Common:Actions.Clear')}
        </LinkButton>
        <Button className={filterButtonsStyles} disabled={disabled} size="small" onClick={onSave}>
          {t('Common:Actions.Apply')}
        </Button>
      </Stack>
    </>
  );
}

export default React.memo(FilterActionsDesktop);
